import Model from '@/models/Model';

export default class Round extends Model {
    /**
     * The api endpoint of the model.
     */
    static get endpoint() {
        return 'rounds';
    }
}
